import React from 'react'
import { Alert } from '@sainsburys-tech/bolt'
import * as Styled from './QandASubmitted.styles'

function QuestionSubmitted({ ...props }) {
  if (props.submitResponse.HasErrors) {
    return (
      <Styled.Wrapper>
        <Alert kind='error' isCloseable={false}>
          Sorry, we are having trouble submitting your question, please try again or check back later.
        </Alert>
      </Styled.Wrapper>
    )
  }
  return (
    <Styled.Wrapper>
      <Styled.Heading>Thank you for your {props.type === 'question' ? 'question' : 'answer'}</Styled.Heading>
      <Styled.Message>
        Your {props.type === 'question' ? 'question' : 'answer'} has been submitted. Please note it may take up to 24
        hours to appear.
      </Styled.Message>
    </Styled.Wrapper>
  )
}

export default QuestionSubmitted
